module.exports = __webpack_public_path__ + "2.png?a1369bb6840788cb78c6909f75b105b8";


//////////////////
// WEBPACK FOOTER
// ./images/pricing/2.png
// module id = 15
// module chunks = 0